import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { I18nProvider } from './i18n';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './components/ui/Toast';
import { RequireAuth } from './components/layout/RequireAuth';
import { Landing } from './screens/Landing';
import { Auth } from './screens/Auth';
import { Bench } from './screens/Bench';
import { UploadStudio } from './screens/UploadStudio';
import { JobReview } from './screens/JobReview';
import { AssetLibrary } from './screens/AssetLibrary';
import { VocalWorkspace } from './screens/VocalWorkspace';
import { Submissions } from './screens/Submissions';
import { ListingComposer } from './screens/ListingComposer';
import { Marketplace } from './screens/Marketplace';
import { CreatorDirectory } from './screens/CreatorDirectory';
import { Onboarding } from './screens/Onboarding';
import { ListingDetail } from './screens/ListingDetail';
import { CreatorStorefront } from './screens/CreatorStorefront';
import { Purchases } from './screens/Purchases';
import { Account } from './screens/Account';
import { NotFound } from './screens/NotFound';
import { AppShell } from './components/layout/AppShell';
import { Analytics } from './components/Analytics';

export function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <Analytics />
            <Routes>
              {/* Public */}
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />

              {/* Public marketplace inside the app shell */}
              <Route
                path="/market"
                element={
                  <AppShell>
                    <Marketplace />
                  </AppShell>
                }
              />
              <Route
                path="/market/:id"
                element={
                  <AppShell>
                    <ListingDetail />
                  </AppShell>
                }
              />
              {/* Public creator storefront — the SEO front door (Wingspan cut 9) */}
              <Route
                path="/u/:handle"
                element={
                  <AppShell>
                    <CreatorStorefront />
                  </AppShell>
                }
              />
              {/* Public creator directory — the browse-all front door (F-054). */}
              <Route
                path="/creators"
                element={
                  <AppShell>
                    <CreatorDirectory />
                  </AppShell>
                }
              />

              {/* Protected producer surfaces */}
              <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
              <Route path="/bench" element={<RequireAuth><Bench /></RequireAuth>} />
              <Route path="/studio" element={<RequireAuth><UploadStudio /></RequireAuth>} />
              <Route path="/review/:jobId" element={<RequireAuth><JobReview /></RequireAuth>} />
              <Route path="/library" element={<RequireAuth><AssetLibrary /></RequireAuth>} />
              <Route path="/vocal" element={<RequireAuth><VocalWorkspace /></RequireAuth>} />
              <Route path="/submissions" element={<RequireAuth><Submissions /></RequireAuth>} />
              <Route path="/listings/new" element={<RequireAuth><ListingComposer /></RequireAuth>} />
              <Route path="/purchases" element={<RequireAuth><Purchases /></RequireAuth>} />
              <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />

              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
